<template>
  <div
    class="smiles-wrapper flex-wrap"
    @mouseleave="$emit('closeSmilesWrapper')"
    @mouseenter="$emit('openSmilesWrapper')"
  >
    <div v-for="(smile, index) in smiles" :key="index">
      <img :src="smile.url" :alt="smile.name" @click="$emit('chooseSmile', ` ${smile.name}`)" />
    </div>
  </div>
</template>

<script>
import { plChatConstants } from '@/constants'

export default {
  data: () => {
    return {
      smiles: plChatConstants.smiles,
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.smiles-wrapper {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  width: 110px;
  bottom: 30px;
  padding: 10px;
  border-radius: 5px;
  background-color: lightgray;
  z-index: 100;

  div {
    flex-basis: 25%;
    text-align: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
